/**
 * Variant State Filter
 * Filters product variants based on user's state from localStorage
 */

class VariantStateFilter {
  constructor() {
    // Check if allowed states filter is enabled
    this.isEnabled = window.allowedStatesEnabled === true;
    if (!this.isEnabled) return;

    this.userState = localStorage.getItem('user_state');
    if (!this.userState) return;

    this.filterAllVariants();
    this.setupEventListeners();
    this.observeVariantPickers();
  }

  setupEventListeners() {
    window.addEventListener('zipcodeUpdated', (e) => {
      if (!this.isEnabled) return;
      this.userState = e.detail?.state || localStorage.getItem('user_state');
      this.filterAllVariants();
    });
  }

  filterAllVariants() {
    if (!this.isEnabled || !this.userState) return;

    document.querySelectorAll('variant-picker').forEach(picker => {
      this.filterOptions(picker, '.variant-option__button-label', 'label');
      this.filterOptions(picker, '.variant-option__select option', 'option');
    });
  }

  filterOptions(picker, selector, type) {
    const elements = picker.querySelectorAll(selector);
    
    elements.forEach(el => {
      const input = type === 'label' ? el.querySelector('input[type="radio"]') : el;
      const allowedStates = input?.dataset.allowedStates;

      if (!allowedStates) return;

      const isAllowed = allowedStates.split(',').map(s => s.trim()).includes(this.userState);
      
      if (!isAllowed) {
        el.classList.add('variant-hidden-by-state');
        
        if (type === 'option') {
          el.disabled = true;
        } else if (input?.checked) {
          input.checked = false;
        }
      }
    });

    if (type === 'label') this.selectFirstAvailable(picker);
  }

  selectFirstAvailable(picker) {
    picker.querySelectorAll('.variant-option--buttons').forEach(fieldset => {
      const checked = fieldset.querySelector('input:checked')?.closest('.variant-option__button-label');
      
      if (checked?.classList.contains('variant-hidden-by-state')) {
        const firstVisible = fieldset.querySelector('.variant-option__button-label:not(.variant-hidden-by-state) input');
        if (firstVisible) {
          firstVisible.checked = true;
          firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    picker.querySelectorAll('.variant-option__select').forEach(select => {
      const selected = select.querySelector('option[selected]');
      if (selected?.disabled || selected?.classList.contains('variant-hidden-by-state')) {
        const firstVisible = select.querySelector('option:not([disabled]):not(.variant-hidden-by-state)');
        if (firstVisible) {
          firstVisible.selected = true;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  observeVariantPickers() {
    let timeoutId = null;

    new MutationObserver((mutations) => {
      let hasVariantChanges = false;
      
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const isVariantPicker = node.tagName === 'VARIANT-PICKER';
            const hasVariantPicker = node.querySelector?.('variant-picker');
            
            if (isVariantPicker || hasVariantPicker) {
              hasVariantChanges = true;
            }
          }
        });
      });

      if (hasVariantChanges) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => this.filterAllVariants(), 100);
      }
    }).observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VariantStateFilter());
} else {
  new VariantStateFilter();
}
